'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (app) {
  app.factory('scrollDelegate', function ($timeout, $q, $ionicScrollDelegate) {

    /**
     * 滚动到顶部
     * @param {Object} delegateHandle
     * @param {Boolean} shouldAnimate
     * @return {Promise}
     */
    function scrollTop() {
      var delegateHandle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var shouldAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var delegate = $ionicScrollDelegate;
      if (delegateHandle) {
        delegate = $ionicScrollDelegate.$getByHandle(delegateHandle);
      }
      var deferred = $q.defer();

      delegate.scrollTop(shouldAnimate);

      $timeout(function () {
        deferred.resolve();
      }, 200);

      return deferred.promise;
    }

    /**
     * 滚动到底部
     * @param {Object} delegateHandle
     * @param {Boolean} shouldAnimate
     * @return {Promise}
     */
    function scrollBottom() {
      var delegateHandle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var shouldAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var delegate = $ionicScrollDelegate;
      if (delegateHandle) {
        delegate = $ionicScrollDelegate.$getByHandle(delegateHandle);
      }
      var deferred = $q.defer();

      delegate.scrollBottom(shouldAnimate);

      $timeout(function () {
        deferred.resolve();
      }, 200);

      return deferred.promise;
    }

    /**
     * 处罚refresher 刷新
     * @param {Object} delegateHandle
     */
    function triggerRefresh(delegateHandle) {

      var deferred = $q.defer();

      var delegate = $ionicScrollDelegate.$getByHandle(delegateHandle);

      delegate.scrollTop(true);

      $timeout(function () {

        var scrollView = delegate.getScrollView();

        if (!scrollView || !scrollView.__publish) {
          return;
        }

        scrollView.__publish(scrollView.__scrollLeft, -scrollView.__refreshHeight, scrollView.__zoomLevel, true);

        var d = new Date();

        scrollView.refreshStartTime = d.getTime();

        scrollView.__refreshActive = true;
        scrollView.__refreshHidden = false;
        if (scrollView.__refreshShow) {
          scrollView.__refreshShow();
        }
        if (scrollView.__refreshActivate) {
          scrollView.__refreshActivate();
        }
        if (scrollView.__refreshStart) {
          scrollView.__refreshStart();
        }

        deferred.resolve();
      }, 100);

      return deferred.promise;
    }

    /**
     * 刷新scroll 高度
     * @param {Object} delegateHandle
     */
    function resize() {
      var delegateHandle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var delegate = $ionicScrollDelegate;
      if (delegateHandle) {
        delegate = $ionicScrollDelegate.$getByHandle(delegateHandle);
      }

      var deferred = $q.defer();

      delegate.resize();

      $timeout(function () {
        deferred.resolve();
      }, 200);

      return deferred.promise;
    }

    return {
      scrollTop: scrollTop,
      scrollBottom: scrollBottom,
      triggerRefresh: triggerRefresh,
      resize: resize
    };
  });

  return app;
};

require('angular');

require('ionic');

; /**
   * $ionicScrollDelegate
   * 拓展方法
   */


//////////////////
// WEBPACK FOOTER
// ./src/lib/ionic1.x-common/services/scrollDelegate.js
// module id = 164
// module chunks = 0